import { useState } from 'react';

const s = {
  page: { minHeight: '100vh', backgroundColor: '#f5f5f3', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif' },
  card: { backgroundColor: '#fff', border: '0.5px solid #e8e8e8', borderRadius: '8px', padding: '40px', width: '100%', maxWidth: '380px' },
  header: { marginBottom: '28px' },
  title: { fontSize: '18px', fontWeight: '700', color: '#1a1a1a', letterSpacing: '-0.3px', marginBottom: '4px' },
  subtitle: { fontSize: '12px', color: '#aaa' },
  error: { backgroundColor: '#fdecea', color: '#c0392b', padding: '10px 14px', borderRadius: '6px', marginBottom: '16px', fontSize: '13px' },
  resendWrap: { backgroundColor: '#fff8e1', border: '0.5px solid #ffe082', borderRadius: '6px', padding: '12px 14px', marginBottom: '16px' },
  resendText: { fontSize: '13px', color: '#666', marginBottom: '8px' },
  resendMsg: { fontSize: '13px', color: '#2e7d32', fontWeight: '500' },
  resendBtn: { fontSize: '13px', color: '#c0392b', background: 'none', border: 'none', cursor: 'pointer', padding: 0, textDecoration: 'underline', fontWeight: '500' },
  label: { display: 'block', fontSize: '12px', fontWeight: '500', color: '#666', marginBottom: '6px' },
  input: { width: '100%', padding: '9px 12px', border: '0.5px solid #e0e0e0', borderRadius: '6px', fontSize: '13px', outline: 'none', color: '#1a1a1a', marginBottom: '16px', boxSizing: 'border-box' },
  btn: { width: '100%', padding: '10px', backgroundColor: '#1a1a1a', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '500', cursor: 'pointer' },
  btnDisabled: { width: '100%', padding: '10px', backgroundColor: '#ccc', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '500' },
  footer: { marginTop: '20px', textAlign: 'center', fontSize: '12px', color: '#aaa' },
  link: { color: '#1a1a1a', textDecoration: 'none', fontWeight: '500' },
  forgotLink: { display: 'block', textAlign: 'center', marginTop: '12px', fontSize: '12px', color: '#aaa', textDecoration: 'none' },
  backLink: { display: 'block', textAlign: 'center', marginTop: '16px', fontSize: '12px', color: '#bbb', textDecoration: 'none' },
};

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [resendMsg, setResendMsg] = useState('');
  const [resendLoading, setResendLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setShowResend(false);
    setLoading(true);
    try {
      const res = await fetch((process.env.REACT_APP_API_URL || '') + '/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (!res.ok) {
        const errMsg = data.error || 'Login failed. Please try again.';
        setError(errMsg);
        if (errMsg.toLowerCase().includes('verif')) setShowResend(true);
        return;
      }
      localStorage.setItem('token', data.token);
      localStorage.setItem('restaurant', JSON.stringify(data.restaurant));
      window.location.href = '/dashboard';
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setResendLoading(true);
    setResendMsg('');
    try {
      const res = await fetch((process.env.REACT_APP_API_URL || '') + '/api/auth/resend-verification', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (!res.ok) { setResendMsg(data.error || 'Failed to resend'); return; }
      setResendMsg('Verification email sent. Please check your inbox.');
    } catch {
      setResendMsg('Something went wrong. Please try again.');
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.header}>
          <p style={s.title}>Menu Board</p>
          <p style={s.subtitle}>Sign in to your account</p>
        </div>
        {error && <p style={s.error}>{error}</p>}
        {showResend && (
          <div style={s.resendWrap}>
            <p style={s.resendText}>Didn't receive the verification email?</p>
            {resendMsg ? (
              <p style={s.resendMsg}>{resendMsg}</p>
            ) : (
              <button style={s.resendBtn} onClick={handleResend} disabled={resendLoading}>
                {resendLoading ? 'Sending...' : 'Resend verification email'}
              </button>
            )}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <label style={s.label}>Email</label>
          <input style={s.input} type="email" value={email} onChange={e => setEmail(e.target.value)} required />
          <label style={s.label}>Password</label>
          <input style={s.input} type="password" value={password} onChange={e => setPassword(e.target.value)} required />
          <button style={loading ? s.btnDisabled : s.btn} type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
        <a href="/forgot-password" style={s.forgotLink}>Forgot password?</a>
        <p style={s.footer}>Don't have an account? <a href="/register" style={s.link}>Sign up</a></p>
        <a href="/" style={s.backLink}>Back to home</a>
      </div>
    </div>
  );
}

export default Login;
